import { useFeatureFlagVariantKey } from 'posthog-js/react';

const useFeatureFlags = (flagKey, flagVariant) => useFeatureFlagVariantKey(flagKey) === flagVariant;

export default useFeatureFlags;
